import requestApiGuest from '@Service/RequestApiMiddlewareGuest';

const contact = '/contact';

export default {
  sendContact(data) {
    return requestApiGuest.post(`${contact}`, data);
  }
};
